export default __webpack_public_path__ + "static/media/IMG_5416-opt.71b4be67.jpg";